'use client';

import NextError from 'next/error';
import { useEffect } from 'react';

import { captureException } from '../util/sentryClient';
import { wasReportedOnServer } from '../util/wasReportedOnServer';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Server-Render-Fehler sind ueber onRequestError schon gemeldet, siehe wasReportedOnServer.
    if (wasReportedOnServer(error)) return;
    captureException(error);
  }, [error]);

  return (
    // NextError renders its message in English, and the locale isn't available this far
    // up the tree (global-error sits outside the [locale] segment).
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
